/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Method_ForwardInputs */

const cs_addr_method_forward = /** @type {(inputs: Addr_Method_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RÚIAN · podle adresy`)
};

const en_addr_method_forward = /** @type {(inputs: Addr_Method_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RÚIAN · from address`)
};

/**
* | output |
* | --- |
* | "RÚIAN · from address" |
*
* @param {Addr_Method_ForwardInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_method_forward = /** @type {((inputs?: Addr_Method_ForwardInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Method_ForwardInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_method_forward(inputs)
	return cs_addr_method_forward(inputs)
});